// @flow

const Routes = {
    Home: 'home',
    ApiProducts: 'apiproducts',
    Docs: 'docs',
    Api: 'api',
    ChangeLog: 'changelog',
    Support: 'support',
    ContactSupport: 'contact-support',
    GetDocs: 'docs-getdocuments',
    DownloadDocs: 'docs-downloaddocuments',
    DocsBinder:'docs-bindertemplate',
    DocsServiceType:'docs-servicetype',
    DocsOfficeLocation:'docs-officelocation',
    DocsSate:'docs-state',
    DocsPage:'docs-page',
    SignIn: 'signin',
    ApiDocs:'api-docs',
    Download:'download'

};

export default Routes;
